<template>
  <div>
    <pc-header activeIndex="my-profile"></pc-header>
    <div class="container">
      <div class="row">
        <div class="col">
          <h2 v-loading="loading_profile" class="mt-5">My Profile</h2>

          <div class="my-profile" v-if="!loading_profile && profile">
            <h6 class="text-secondary mb-5">{{profile.email}}</h6>
            <div class="trial" v-if="!profile.is_paying_customer">
              <div class="trial__available" v-if="profile.trial_available">
                Trial: <span class="text-success">available, expires on {{profile.trial_until | moment('MMMM Do YYYY') }}</span>
              </div>
              <div class="trial__expired" v-if="!profile.trial_available">
                Trial: <span class="text-danger">expired on {{profile.trial_until | moment('MMMM Do YYYY') }}</span>
              </div>
            </div>
            <div v-if="profile.is_paying_customer">
              <div>Licence purchased</div>
              <div class="text-success mt-2">
                Valid until {{profile.license_valid_until | moment('MMMM Do YYYY') }}
              </div>
              <!--          <div v-if="profile.renew_automatically" class="mt-5">-->
              <!--            <div>Automatic renewal from card **** {{profile.last_four}}</div>-->
              <!--            <div class="text-danger mt-2 small"><a @click="showSubscriptionCancelModal()" class="autorenew__cancel-link">Cancel subscription</a></div>-->
              <!--          </div>-->
            </div>
            <div class="pending-order mt-2" v-if="has_at_at_least_one_pending_order">
              <i class="el-icon-loading mr-2"></i>
              <span>We received your payment, but it is not yet approved by payment gateway.</span>
              <div> Usually it takes up to 10 minutes for transaction to be approved.</div>
              <div> Contact <a href="mailto:support@pycrunch.com">support</a>, if you continue to see this.</div>

            </div>
            <div class="mt-4 order-history">
              <span class="order-history__link" @click="show_order_history()">Order history</span></div>
            <div class="pay mt-5">
              <div class="text-secondary" v-if="!profile.is_paying_customer">
                Purchase license to continue using PyCrunch:
              </div>
              <div class="text-secondary" v-if="profile.is_paying_customer">
                Save money by purchasing license for 1 year (will be added to your licence):
              </div>
              <div class="mt-2 text-secondary" v-if="profile.is_paying_customer">
                Or, buy another month to not lose access to PyCrunch
              </div>
              <div class="cards flex-md-row flex-column align-items-center">
                <el-card class="box-card card m-5">

                  <div class="card__title">
                    <h3>Monthly License</h3>
                  </div>
                  <div class="card__description">
                    Subscription for 1 month
                  </div>
                  <div class="card__amount mt-4">
                    <h4>$4.99
                      <!--                <span class="text-secondary" v-if="enable_auto_renew"> / month</span>-->
                    </h4>
                  </div>
                  <div class="card__auto-renew">
                    <el-checkbox :disabled="true" v-model="enable_auto_renew" title="Payment system is playing tricks, we hope to provide automatic subscription renewal as soon as we change payment gateway">
                      Auto-renew (not available now)
                    </el-checkbox>
                  </div>
                  <el-button class="mt-3" @click="pay_now_month()">Pay now</el-button>
                </el-card>
                <el-card class="box-card card card--year m-5">
                  <div class="card__title"><h3>1 Year License</h3></div>
                  <div class="card__description">
                    Licence for 1 year

                  </div>
                  <div class="card__amount mt-4">
                    <h4>$49.99
                    </h4>
                  </div>
                  <div class="text-secondary mt-1">One time payment</div>
                  <el-button type="primary" class="mt-4" @click="pay_now_year()">Pay now</el-button>

                </el-card>
              </div>
            </div>
            <el-dialog
                title="Cancel subscription?"
                :visible.sync="subscriptionCancelDialogVisible"
                :before-close="dismissCancellationDialog">
              <div>
                <div>Are you sure you want to cancel your subscription?</div>
                <div class="mt-2">You will not be billed anymore automatically.</div>
                <div class="mt-4">After cancellation, your licence will continue to be active until <span
                    class="text-success">{{profile.license_valid_until | moment('MMMM Do YYYY') }}</span>.
                </div>
                <div class="mt-4">To continue using PyCrunch after that date, you will need to purchase another
                  license.
                </div>
              </div>
              <span slot="footer" class="dialog-footer">
    <el-button @click="dismissCancellationDialog()">Go Back</el-button>
    <el-button type="primary" @click="willCancelSubscription()">Cancel Subscription</el-button>
  </span>
            </el-dialog>

            <el-dialog
                title="Order History"
                :visible.sync="show_order_history_modal"
                width="70%"
            >
              <div v-if="profile">
                <el-table
                    :data="profile.orders"
                    style="width: 100%">
                  <el-table-column
                      label="Date"
                      width="210"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.timestamp | moment('MMM DD, YYYY, h:mm:ss a')}}
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="order_type"
                      width="110"

                      label="Type">
                  </el-table-column>
                  <el-table-column
                      label="Status"
                      width="95">
                    <template slot-scope="scope">
                      <el-tag :type="label_from_status(scope.row.status)" style="width: 100%; text-align: center">{{
                        scope.row.status }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="card_masked"
                      label="Card"
                      width="120"
                  >
                  </el-table-column>
                  <el-table-column
                      prop="amount"
                      label="Amount">
                  </el-table-column>
                  <el-table-column
                      prop="currency"
                      label="Currency">
                  </el-table-column>

                </el-table>
              </div>
              <span slot="footer" class="dialog-footer">
    <el-button @click="show_order_history_modal = false">Close</el-button>
  </span>
            </el-dialog>
          </div>

          <el-button @click="log_out" class="el-button--danger mt-4 mb-5"> Log out</el-button>
        </div>
      </div>
    </div>
    <pc-footer></pc-footer>
  </div>
</template>

<script>
  import PcHeader from '@/components/pc-header.component'
  import {mapActions, mapState} from 'vuex'
  import {track} from '../ga-events'
  import axios from 'axios'
  import config from '../config'
  import PcFooter from '../views/PcFooter'

  export default {
    name: 'my-profile',
    data () {
      return {
        loading_profile: true,
        enable_auto_renew: false,
        subscriptionCancelDialogVisible: false,
        show_order_history_modal: false,
      }
    },
    components: {
      PcFooter,
      PcHeader},
    computed: {
      ...mapState(['profile']),
      has_at_at_least_one_pending_order () {
        if (!this.profile) {
          return false
        }

        if (!this.profile.orders) {
          return false
        }

        if (this.profile.orders.filter(e => e.status === 'Pending').length > 0) {
          return true
        }
      },
    },
    methods: {
      ...mapActions(['willLoadProfile', 'logout', 'cancelSubscription']),
      my_way_for_pay: function (wayforpay, response) {
        let self = this
        wayforpay.run({
            merchantAccount: response.data.merchant_account,
            merchantDomainName: response.data.merchant_domain_name,
            authorizationType: 'SimpleSignature',
            merchantSignature: response.data.signature,
            orderReference: response.data.order_reference,
            orderDate: response.data.order_date,
            amount: response.data.product_price,
            // amount: 0,
            currency: response.data.currency,
            productName: response.data.product_name,
            productPrice: response.data.product_price,
            productCount: '1',
            clientEmail: this.tryToGetUserEmail(),
            serviceUrl: response.data.service_url,
            // regularOn: 1,
            // regularMode: 'monthly',
            // dateNext: '29.08.2019',
            // requestType: 'VERIFY',
            // theme : "bindcard"

            // straightWidget: true,

            // clientPhone: "380631234567",
            // language: "UA"
          },
          response => {
            // on approved
            this.$alert(response, 'Payment approved', {
              confirmButtonText: 'OK',
              callback: action => {
                this.$message({
                  type: 'info',
                  message: 'Payment approved',
                })
                this.reload_profile()
              },
            })
          },
          response => {
            // on declined
            this.$alert(response, 'Payment declined', {
              confirmButtonText: 'OK',
              callback: action => {
                this.$message({
                  type: 'info',
                  message: 'Payment declined',
                })
                this.reload_profile()

              },
            })
          },
          response => {
            // on pending or in processing
            this.$alert(response, 'Payment processing', {
              confirmButtonText: 'OK',
              callback: action => {
                this.$message({
                  type: 'info',
                  message: 'Payment processing... It may take up to 10 minutes for payment ot verify',
                })
                this.reload_profile()


              },
            })
          },
        )
      },
      async pay_now_month () {
        this.pay_now_generic('month')
      },
      async pay_now_year () {
        this.pay_now_generic('year')
      },
      test_alert () {
        this.$alert('xxx', 'Payment processing', {
          confirmButtonText: 'OK',
          callback: action => {
            this.$message({
              type: 'info',
              message: 'Payment processing... It may take up to 10 minutes for payment ot verify',
            })
            this.reload_profile()


          },
        })
      },
      async pay_now_generic (product) {
        track('my_profile', 'pay_now_'+ product + '_click', this.tryToGetUserEmail())

        var wayforpay = new Wayforpay()
        let response = await axios.post(config.api_root + '/api/pay-now', {
          product: product,
          auto_renew: this.enable_auto_renew,
        })
        this.my_way_for_pay(wayforpay, response)
      },
      tryToGetUserEmail: function () {
        let eventLabel = 'unknown'
        if (this.profile && this.profile.email) {
          eventLabel = this.profile.email
        }
        return eventLabel
      },

      label_from_status (status) {
        if (status === 'created') {
          return 'info'
        }
        if (status === 'Approved') {
          return 'success'
        }
        if (status === 'Refunded') {
          return 'danger'
        }
        return '--'

      },
      showSubscriptionCancelModal () {
        let eventLabel = this.tryToGetUserEmail()
        track('my_profile', 'click_on_cancel_subscription', eventLabel)
        this.subscriptionCancelDialogVisible = true

      },
      dismissCancellationDialog () {
        let eventLabel = this.tryToGetUserEmail()
        track('my_profile', 'dismiss_cancel_subscription_modal', eventLabel)
        this.subscriptionCancelDialogVisible = false
      },
      show_order_history () {
        this.show_order_history_modal = true
      },
      async willCancelSubscription () {
        this.subscriptionCancelDialogVisible = false
        this.loading_profile = true
        let eventLabel = this.tryToGetUserEmail()
        track('my_profile', 'cancel_subscription', eventLabel)

        await this.cancelSubscription({})
        this.loading_profile = false

      },
      log_out () {
        let eventLabel = this.tryToGetUserEmail()

        track('my_profile', 'logout', eventLabel)

        this.logout()
        this.$router.replace('/')
      },
      async reload_profile () {
        console.log('reloading profile...')
        this.loading_profile = true
        await this.willLoadProfile()
        this.loading_profile = false
      },
    },

    async mounted () {
      await this.reload_profile()
    },
  }
</script>

<style scoped>
  .cards {
    display: flex;
    /*flex-direction: column;*/
  }

  .autorenew__cancel-link {
    border-bottom: 1px solid #dc3545;
    cursor: pointer;
  }

  .card {
    width: 320px;
  }

  @media (max-width: 577px) {
    .card {
      width: 100%;
    }
  }

  .pending-order {
    display: inline-block;
    padding: 0 10px;
    line-height: 30px;
    font-size: 12px;
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fdf6ec;
    border-color: #faecd8;
    color: #e6a23c;
  }

  .order-history__link {
    font-size: 0.9em;
    border-bottom: 1px dashed #1e7e34;
    cursor: pointer;
  }


</style>